import { color } from '@op/opds.tokens';
import classes from './Donut.module.scss';
import DonutLayer from './DonutLayer';

interface Data {
  label: string;
  value: number;
}

interface Props {
  data: Data[];
  isSmall?: boolean;
  isLarge?: boolean;
}

// List of arc colors
const colors = [
  color.indicator.default,
  color.indicator.passive,
  color.text.secondary,
  color.indicator.warning,
  color.indicator.positive,
  color.indicator.notification,
  color.indicator.negative,
  color.text.default,
  color.background.tertiary,
  color.text.highlight.small,
  color.text.positive.small,
];

const Donut = ({ data, isSmall, isLarge }: Props): JSX.Element => {
  const nonZeroValues = data.filter((element) => element.value > 0);
  // Count sum of values for degree translator
  const sumOfValues = nonZeroValues.reduce((sum: number, current: { value: number }) => {
    return sum + current.value;
  }, 0);

  // Create array with accumulated values
  const accumulatedValues: number[] = [0];
  let accumulator = 0;
  nonZeroValues.forEach((element: { value: number }) => {
    accumulator += element.value;
    accumulatedValues.push(accumulator);
  });

  // Check if there is data
  const hasData: boolean = nonZeroValues.length > 0;

  return (
    <div
      className={`
        ${isSmall ? classes.smallcontainer : classes.container} 
        ${isLarge ? classes.largecontainer : ''}
      `}
    >
      {hasData ? (
        nonZeroValues.map((element: Data, index: number) => (
          <DonutLayer
            from={accumulatedValues[index]}
            to={accumulatedValues[index] + element.value}
            total={sumOfValues}
            color={colors[index]}
            key={element.label}
            segmentIndex={index}
            totalSegmentCount={nonZeroValues.length}
          />
        ))
      ) : (
        <DonutLayer
          from={0}
          to={100}
          total={100}
          color={color.background.tertiary}
          key="donutLayer null"
        />
      )}
    </div>
  );
};

export default Donut;
